export default __webpack_public_path__ + "static/media/1730.33e12ef5.png";